// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Tickets de ASOCEBU por cruce (clivage) — admin-asocebu.md.

export const asocebuPaths = {
    crosses:    ()   => 'admin/asocebu/crosses',
    tickets:    ()   => 'admin/asocebu/tickets',
    ticketItem: (id) => `admin/asocebu/tickets/${id}`,
};
